
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class UserReviewRequestIcon extends Vue {
  @Prop() requested!: boolean;
  @Prop() canRequest!: boolean;

  public hovered = false;

  public requestClicked() {
    this.$emit("request-clicked");
  }

  public unrequestClicked() {
    this.$emit("unrequest-clicked");
  }
}
